module.exports = __webpack_public_path__ + "img/self-icon.2b95546c.svg";